import React from 'react';
import Icon from '@mui/material/Icon';
import Chip from '@mui/material/Chip';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { FieldCard } from '../ui/FieldCard';

export function MemberSummaryCard({ form, canSave, saving }) {
  const fullName = (
    String(form.name || '').trim() +
    ' ' +
    String(form.surname || '').trim()
  ).trim();

  return (
    <FieldCard icon="check_circle" tone="sky" title="Özet" subtitle="Kaydetmeden önce kontrol">
      <MDBox sx={{ display: 'grid', gap: 0.8 }}>
        <MDBox display="flex" justifyContent="space-between" gap={2}>
          <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
            Ad Soyad
          </MDTypography>
          <MDTypography variant="caption" fontWeight="bold" sx={{ textAlign: 'right' }}>
            {fullName || '-'}
          </MDTypography>
        </MDBox>

        <MDBox display="flex" justifyContent="space-between" gap={2}>
          <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
            Telefon
          </MDTypography>
          <MDTypography variant="caption" fontWeight="bold" sx={{ textAlign: 'right' }}>
            {String(form.phone || '').trim() || '-'}
          </MDTypography>
        </MDBox>

        <MDBox display="flex" justifyContent="space-between" gap={2}>
          <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
            Doğum Tarihi
          </MDTypography>
          <MDTypography variant="caption" fontWeight="bold" sx={{ textAlign: 'right' }}>
            {form.birthDate ? String(form.birthDate) : '-'}
          </MDTypography>
        </MDBox>

        <Chip
          size="small"
          variant="outlined"
          sx={{ borderRadius: '999px', mt: 0.5 }}
          icon={
            <Icon sx={{ fontSize: 16 }}>
              {saving ? 'hourglass_top' : canSave ? 'done' : 'error_outline'}
            </Icon>
          }
          label={saving ? 'Kaydediliyor…' : canSave ? 'Kayda hazır' : 'Eksik bilgi'}
        />
      </MDBox>
    </FieldCard>
  );
}
